import { Close, Send } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { isJson } from '../../keys'
import ChatBox from './ChatBox'
import { Arik_Bot, mainInstructions, MdbotAbout } from './chatexample'
import { runGenAi } from './geminiUtilities'

export default function Mobot() {
    const [showBot, setShowBot] = useState(false)
    const [messageText, setMessageText] = useState('')
    const [newText, setNewText] = useState('');
    const customData = localStorage.getItem('dataset') == null ? MdbotAbout : `${localStorage.getItem('dataset')} ${mainInstructions}`;
    const [loader, setLoader] = useState(false);
    const history = JSON.parse(localStorage.getItem('mobotChatHistory')) || [];
    const json_history = [
        {
            "role": "user",
            "parts": `${customData}`,

        },
        {
            "role": "model",
            "parts": "Great to meet you. I can now answer any question related to the data added!",
            "prompts": [
            ],
            "lists": [],
        },
    ]

    useEffect(() => {
        history[0] = json_history[0];
        history[1] = json_history[1];
        // history[2] = json_history[2];

        localStorage.setItem('mobotChatHistory', JSON.stringify(history));
    }, [messageText])


    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            sendChat('inputPress')
        }
    };

    let messageCreatorObj = {

        mainMessage: [],

        createsNewUserMessage: function (user_message) {
            let newMessage = [
                {
                    role: "user",
                    parts: `${user_message}`,
                }
            ]
            setNewText(Math.random());
            setLoader(true);
            let newMes = history.concat(newMessage);
            this.mainMessage = newMes;
            localStorage.setItem('mobotChatHistory', JSON.stringify(newMes));
        },
        createsModelMessage: function (bot_message) {
            let withModel = this.mainMessage.concat(bot_message);
            localStorage.setItem('mobotChatHistory', JSON.stringify(withModel));
        }
    }

    function sendChat(pressType, promptType) {

        if (pressType === 'inputPress') {
            if (messageText.includes('clear') || messageText.includes('Clear')) {
                localStorage.removeItem('mobotChatHistory');
                setNewText(Math.random());
                return 0
            }
            messageCreatorObj.createsNewUserMessage(messageText)
            function handleResponse(response) {
                try {
                    if (isJson(response.text)) {
                        let responseJson = JSON.parse(response.text);
                        let aiMessage = [
                            {
                                role: 'model',
                                parts: `${responseJson.message}`,
                                lists: `${JSON.stringify(responseJson.lists)}`
                            }
                        ];
                        messageCreatorObj.createsModelMessage(aiMessage);
                        setLoader(false);
                        setNewText(Math.random());
                        setMessageText('');
                    } else {
                        let responseJson = response.text;
                        let aiMessage = [
                            {
                                role: 'model',
                                parts: `${responseJson}`,
                                lists: `[]`
                            }
                        ];
                        messageCreatorObj.createsModelMessage(aiMessage);

                        setLoader(false);
                        setNewText(Math.random());
                        setMessageText('');
                    }
                } catch (e) {
                    console.error('Error handling response:', e);
                    setTimeout(runGenAi(messageText, json_history).then(handleResponse), 2000);
                }
            }
            runGenAi(messageText, json_history).then(handleResponse);
            setMessageText('');

        } else {
            if (promptType == 'E-commerce Bot') {


            } else if (promptType == 'Medical Bot') {


            } else if (promptType == 'Airline Booking Bot') {


            }
        }
    }


    return (
        <div style={{
            fontSize: 12,
        }}>
            <div onClick={() => { setShowBot(true) }} className='shadow-lg bg-white  d-flex justify-content-center align-items-center' style={{
                height: '100px',
                width: '100px',
                borderRadius: '50%',
                position: 'fixed',
                right: '30px',
                bottom: '30px',
                zIndex: 999999999,
            }}>
                <div style={{ position: 'relative' }}>

                    <div className='p-2 scalePop' style={{
                        borderTopLeftRadius: '20px',
                        borderBottomLeftRadius: '20px',
                        borderTopRightRadius: '20px',
                        position: 'absolute',
                        backgroundColor: 'greenyellow',
                        left: '-180px',
                        top: '-40px',
                    }}>
                        <p>Take it for a ride! 🥳</p>
                    </div>
                    <h6 className='robotText'>Chat</h6>
                </div>

            </div>
            {showBot &&
                <div style={{
                    height: '700px',
                    width: '400px',
                    position: 'fixed',
                    right: '10px',
                    bottom: '30px',
                    zIndex: 9999999999,
                    overflowX: 'hidden',
                    // overflowY: 'scroll',
                }} className='rounded rounded-4 bg-white rounded-1 shadow-lg'>
                    <div style={{
                        position: 'relative',
                    }}>

                        <div className='bg-back p-3 d-flex justify-content-between align-items-center w-100' style={{ zIndex: 999999, height: '50px', position: 'sticky', top: 0, }}>
                            <div className='d-flex justify-content-between align-items-center '>
                                <h3 className='robotText text-white'>MObot</h3>
                            </div>

                            <div className='text-white' onClick={() => { setShowBot(false) }}>
                                <Close color='white' />
                            </div>
                        </div>
                        <div className='p-2 pb-5' style={{ overflowY: 'scroll', top: 0, height: '650px', position: 'relative', }}>
                            <ChatBox newText={newText} loader={loader} sendChat={sendChat} />
                        </div>

                        <div className='row justify-content-between bg-back  shadow p-2  align-items-center' style={{ position: 'absolute', right: 12, bottom: 0, width: '100%' }}>
                            <div className='col-11'> <input value={messageText} onKeyPress={handleKeyPress} onChange={(e) => { setMessageText(e.target.value) }} type="text" placeholder='enter your question here' className='form-control rounded-0' />
                            </div>
                            <div onClick={() => { sendChat('inputPress') }} className="col-1 text-white">
                                <Send />
                            </div>

                        </div>

                    </div>

                </div>
            }
        </div>
    )
}
